import { T }         from 'defa-object';
import ControlModule from 'scripts/poppet/control-module';
import template      from './controlPowerAlertView.jst.html';
import { Vue }       from 'vue/defavue';

const powerSwitchOptions     = [
	{ value: 'ON', 	title: T.tc( 'HomeAlert', 'On' ), 	titleContext: 'HomeAlert' },
	{ value: 'OFF', title: T.tc('HomeAlert', 'Off' ),	titleContext: 'HomeAlert' }
];

export const ControlPowerAlertView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	
	className: function () {
		return this._getClassName( 'control-home-alerts' );
	},
	
	onDomRefresh() {
		let self   = this;
		
		new Vue ({
			el: '#power-slider',
			
			bb() {
				return {
					model: self.model,
				};
			},
			
			data() {
				return {
					powerSwitchValue: 'ON',
					powerSwitchOptions,
				}
			},
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= {
						highMains: 'ON' === this.batterySwitchValue,
						lowMains    : 'ON' === this.batterySwitchValue
					};
					self.save( data )
				},
			},
			
			watch: {
				'model.mainsAlarmMask': function (newAttribute){
					this.powerSwitchValue = newAttribute.highMains &&  newAttribute.lowMains ? 'ON' : 'OFF';
				}
			},
			
			created() {
				this.powerSwitchValue = this.model.mainsAlarmMask && this.model.mainsAlarmMask.highMains && this.model.mainsAlarmMask.lowMains  ? 'ON' : 'OFF';
			}
		});
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	save: function (attributes) {
		this.model.set('isValidData', false);
		try {
			this.model.save( attributes, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error  : function (model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			} );
		} catch ( err ) {
			alert( 'Failed syncing' );
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	}
});

export default  ControlPowerAlertView;
